import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["id", "label", "subItems"],
    _excluded2 = ["children"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, mq, transition } from '@rexlabs/styling';
import { usePrevious } from '@rexlabs/react-hooks';
import { Breakpoints } from '@rexlabs/breakpoints';
import { Overlay } from '@rexlabs/overlay';
import { Menu } from '../components/menu';
import { SubMenu } from '../components/sub-menu';
import { useNavigation } from '../context';
import { WIDTHS } from '../utils/constants';
var defaultStyles = StyleSheet({
  navigation: _objectSpread(_objectSpread({
    position: 'relative',
    height: '100%'
  }, transition.styles({
    target: 'navigation.menu',
    property: 'transform',
    duration: 'slow',
    easing: 'smooth'
  })), mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      position: 'absolute',
      overflow: 'hidden',
      width: function width(_ref) {
        var token = _ref.token;
        return token('navigation.menu.expanded.mobile.width', WIDTHS.EXPANDED_MENU.MOBILE);
      },
      boxShadow: function boxShadow(_ref2) {
        var token = _ref2.token;
        return token('navigation.subMenu.boxShadow', token('shadow.medium'));
      },
      transform: function transform(_ref3) {
        var token = _ref3.token;
        return "translateX(-".concat(token('navigation.menu.expanded.mobile.width', WIDTHS.EXPANDED_MENU.MOBILE), ")");
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      position: 'absolute',
      width: function width(_ref4) {
        var token = _ref4.token;
        return token('navigation.menu.expanded.tablet.width', WIDTHS.EXPANDED_MENU.TABLET);
      },
      transform: function transform(_ref5) {
        var token = _ref5.token;
        return "translateX(-".concat(token('navigation.menu.expanded.tablet.width', WIDTHS.EXPANDED_MENU.TABLET), ")");
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: 'fit-content'
    }
  }])),
  navigationVisible: _objectSpread({}, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      transform: "translateX(0)"
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      transform: "translateX(0)"
    }
  }])),
  menuContainer: _objectSpread(_objectSpread({
    position: 'relative',
    height: '100%',
    zIndex: 1
  }, transition.styles.combine({
    presets: [{
      property: 'width',
      duration: 'medium',
      easing: 'smooth'
    }, {
      property: 'transform',
      duration: 'slow',
      easing: 'smooth'
    }]
  })), mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      width: function width(_ref6) {
        var token = _ref6.token;
        return token('navigation.menu.mobile.width', WIDTHS.MENU.MOBILE);
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      width: function width(_ref7) {
        var token = _ref7.token;
        return token('navigation.menu.tablet.width', WIDTHS.MENU.TABLET);
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: function width(_ref8) {
        var token = _ref8.token;
        return token('navigation.menu.desktop.width', WIDTHS.MENU.DESKTOP);
      }
    }
  }])),
  menuContainerActive: _objectSpread({}, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      transform: function transform(_ref9) {
        var token = _ref9.token;
        return "translateX(-".concat(token('navigation.menu.mobile.width', WIDTHS.EXPANDED_MENU.MOBILE), ")");
      }
    }
  })),
  menuContainerExpanded: _objectSpread({}, mq.styles({
    queries: {
      minWidth: 'm'
    },
    styles: {
      width: function width(_ref10) {
        var token = _ref10.token;
        return token('navigation.menu.expanded.desktop.width', WIDTHS.EXPANDED_MENU.DESKTOP);
      }
    }
  })),
  menuContainerCollapsing: _objectSpread({}, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      transitionDelay: '500ms'
    }
  })),
  subMenuContainer: _objectSpread(_objectSpread({
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    pointerEvents: 'none'
  }, transition.styles.combine({
    presets: [{
      property: 'transform',
      duration: 'slow',
      easing: 'smooth'
    }, // We need to delay the opacity transition until
    // the transform has occurred on the way out but
    // we want the transition to happen instantly so
    // that we can see the element before it translates
    {
      property: 'opacity',
      duration: 'immediate',
      easing: 'smooth',
      delay: 'slow'
    }]
  })), mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      transform: function transform(_ref11) {
        var token = _ref11.token;
        return "translateX(".concat(token('navigation.subMenu.mobile.width', WIDTHS.SUB_MENU.MOBILE), ")");
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      transform: function transform(_ref12) {
        var _context;

        var token = _ref12.token;
        return _concatInstanceProperty(_context = "translateX(calc(".concat(token('navigation.menu.tablet.width', WIDTHS.MENU.TABLET), " - ")).call(_context, token('navigation.subMenu.tablet.width', WIDTHS.SUB_MENU.TABLET), "))");
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      opacity: 0,
      boxShadow: function boxShadow(_ref13) {
        var token = _ref13.token;
        return token('navigation.subMenu.boxShadow', token('shadow.medium'));
      },
      transform: function transform(_ref14) {
        var _context2;

        var token = _ref14.token;
        return _concatInstanceProperty(_context2 = "translateX(calc(".concat(token('navigation.menu.desktop.width', WIDTHS.MENU.DESKTOP), " - ")).call(_context2, token('navigation.subMenu.desktop.width', WIDTHS.SUB_MENU.DESKTOP), "))");
      }
    }
  }])),
  subMenuContainerExpanded: _objectSpread({}, mq.styles({
    queries: {
      minWidth: 'm'
    },
    styles: {
      transform: function transform(_ref15) {
        var _context3;

        var token = _ref15.token;
        return _concatInstanceProperty(_context3 = "translateX(calc(".concat(token('navigation.menu.desktop.expanded.width', WIDTHS.EXPANDED_MENU.DESKTOP), " - ")).call(_context3, token('navigation.subMenu.desktop.width', WIDTHS.SUB_MENU.DESKTOP), "))");
      }
    }
  })),
  subMenuContainerActive: _objectSpread({
    pointerEvents: 'all'
  }, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      transform: 'translateX(0)'
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      transform: function transform(_ref16) {
        var token = _ref16.token;
        return "translateX(".concat(token('navigation.menu.tablet.width', WIDTHS.EXPANDED_MENU.TABLET), ")");
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      opacity: 1,
      // Don't delay the opacity transition
      // on the way in
      transitionDelay: '0ms, 0ms',
      transform: function transform(_ref17) {
        var token = _ref17.token;
        return "translateX(".concat(token('navigation.menu.desktop.width', WIDTHS.EXPANDED_MENU.DESKTOP), ")");
      }
    }
  }])),
  subMenuContainerCollapsing: _objectSpread({}, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      transitionDelay: '500ms'
    }
  })),
  stopTransition: {
    transition: 'none'
  }
});
export function Navigation(_ref18) {
  var items = _ref18.items,
      Title = _ref18.Title;
  var s = useStyles(defaultStyles);

  var _useNavigation = useNavigation(),
      activeItem = _useNavigation.activeItem,
      isExpanded = _useNavigation.isExpanded,
      isVisible = _useNavigation.isVisible,
      setActiveItem = _useNavigation.setActiveItem,
      setIsVisible = _useNavigation.setIsVisible;

  var navRef = useRef(null);
  var prevActiveItem = usePrevious(activeItem);
  var prevIsVisible = usePrevious(isVisible);
  useEffect(function () {
    var handleEvent = function handleEvent(e) {
      var _navRef$current, _navRef$current$conta;

      if (navRef.current && !((_navRef$current = navRef.current) !== null && _navRef$current !== void 0 && (_navRef$current$conta = _navRef$current.contains) !== null && _navRef$current$conta !== void 0 && _navRef$current$conta.call(_navRef$current, e.target))) {
        setActiveItem(null); // While we're not using react 18 the `setIsVisible` call
        // _must_ come after the `setActiveItem` call otherwise
        // the logic for checking the `prevIsVisible` vs `isVisible`
        // doesn't work properly (setState calls aren't batched)

        setIsVisible(false);
      }
    };

    window.document.body.addEventListener('click', handleEvent);
    return function () {
      return window.document.body.removeEventListener('click', handleEvent);
    };
  }, [activeItem, setActiveItem, setIsVisible]);
  return /*#__PURE__*/React.createElement(MaybeOverlay, {
    show: activeItem || isVisible
  }, /*#__PURE__*/React.createElement("nav", _extends({}, s('navigation', {
    navigationVisible: activeItem || isVisible
  }), {
    ref: navRef
  }), /*#__PURE__*/React.createElement(Box, s('menuContainer', {
    menuContainerActive: !!activeItem,
    menuContainerExpanded: isExpanded,
    menuContainerCollapsing: prevIsVisible === true && isVisible === false
  }), /*#__PURE__*/React.createElement(Menu, _extends({}, s('menu'), {
    items: items,
    Title: Title
  }))), _mapInstanceProperty(items).call(items, function (_ref19) {
    var id = _ref19.id,
        label = _ref19.label,
        subItems = _ref19.subItems,
        item = _objectWithoutProperties(_ref19, _excluded);

    if (subItems) {
      return /*#__PURE__*/React.createElement(Box, _extends({}, s('subMenuContainer', {
        stopTransition: prevActiveItem !== null && activeItem !== null,
        subMenuContainerExpanded: isExpanded,
        subMenuContainerActive: activeItem === id,
        subMenuContainerCollapsing: prevIsVisible === true && isVisible === false
      }), {
        key: id
      }), /*#__PURE__*/React.createElement(SubMenu, _extends({}, item, {
        id: id,
        title: label,
        items: subItems
      })));
    }

    return null;
  })));
}

function MaybeOverlay(_ref20) {
  var children = _ref20.children,
      props = _objectWithoutProperties(_ref20, _excluded2);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: 'm'
    }
  }, /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Overlay, props, children), window.document.body)), /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      minWidth: 'm'
    }
  }, children));
}